import {DateString, DoctorNote, VideoCall, MeasurementSchedule, isEmpty} from "./EntityFields";
import {UserType} from './UserTypes';
import {User} from './User';
import {MedicalBackground} from './MedicalBackground';
import {Diaries} from './DiaryQuestion';
import {LikertRecord} from './Likert';
import { NNotification } from "./NNotification";

type PhoneNumber = string;

interface EmergencyContact {
	name: string;
	phoneNumber: PhoneNumber;
}

export interface LocationAddress {
	country: string;
	department: string;
	province: string;
	district: string;
}

export enum EducationLevelType {
	PRIMARY_COMPLETED = 'PRIMARY_COMPLETED',
	SECONDARY_COMPLETED = 'SECUNDARY_COMPLETED',
	TECHNICAL_STUDIES = 'TECHNICAL_STUDIES',
	UNIVERSITY_STUDENT = 'UNIVERSITY_STUDENT',
	UNIVERSITY_STUDIES_COMPLETED = 'UNIVERSITY_STUDIES_COMPLETED',
}

export const educationLevels = [
	{ label: 'Primaria completa', value: EducationLevelType.PRIMARY_COMPLETED },
	{ label: 'Secundaria completa', value: EducationLevelType.SECONDARY_COMPLETED },
	{ label: 'Estudios técnicos', value: EducationLevelType.TECHNICAL_STUDIES },
	{ label: 'Estudiante universitario', value: EducationLevelType.UNIVERSITY_STUDENT },
	{ label: 'Estudios universitarios completados', value: EducationLevelType.UNIVERSITY_STUDIES_COMPLETED },
]

export enum WorkType {
	HOME_OFFICE = 'HOME_OFFICE',
	IN_OFFICE = 'IN_OFFICE',
	MIXED_SCHEME = 'MIXED_SCHEME'
}

export class Patient implements User {
	id = '';
	email = '';
	typeUser = UserType.Patient;
	
	notifications : NNotification[] = [];

	firstName: string;
	lastName: string;
	createdAt: Date;
	dni?: string;
	phoneNumber?: PhoneNumber;
	genre?: string;
	birthDate?: DateString;
	emergencyContact?: EmergencyContact;
	address?: LocationAddress;
	educationLevel?: EducationLevelType;
	ocupation?: string;
	workScheme?: WorkType;

	hasFilledPersonalInformation : boolean = false;

	healthBackground?: MedicalBackground[];
	
	diaries? : Diaries;
	likertRecords? : LikertRecord[];
	lastMeasurementRecord? : MeasurementRecord;
	measurementRecords? : MeasurementRecord[];
	
	doctorNotes? : DoctorNote[];
	videoCalls? : VideoCall[];
	lastMeasurementSchedule? : MeasurementSchedule;
	// measurementSchedule? : MeasurementSchedule[];
	// extraMeasurementSchedule? : RoutineMeasurement[];

	constructor(id : string) {
		this.id = id
		this.email = ''

		this.firstName = ''
		this.lastName = ''
		this.createdAt = new Date()
	}

	setAdditionalInformation(
		notifications: NNotification[],
		dni: string,
		phoneNumber: PhoneNumber,
		genre: string,
		birthDate: DateString,
		emergencyContact: EmergencyContact,
		address: LocationAddress,
		educationLevel: EducationLevelType,
		ocupation: string,
		workScheme: WorkType,
		hasFilledPersonalInformation: boolean,
	) {
		this.notifications = notifications

		this.dni = dni
		this.phoneNumber = phoneNumber
		this.genre = genre
		this.birthDate = birthDate
		this.emergencyContact = emergencyContact
		this.address = address
		this.educationLevel = educationLevel
		this.ocupation = ocupation
		this.workScheme = workScheme

		this.hasFilledPersonalInformation = hasFilledPersonalInformation
		this.healthBackground = []
	}

	setMedicalBackground(
		healthBackground: MedicalBackground[]
	) {
		this.healthBackground = healthBackground
	}

	static isValidHealthBackground(patient : Patient) : boolean {
		if (patient.healthBackground === undefined) {
			return false
		}
		for (let i = 0; i < patient.healthBackground!.length; i++) {
			const hb = patient.healthBackground[i];
			if (hb.answer === '') {
				return false
			}
		}
		return true
	}

	static validateNonEmptyRegistrationFields(patient : Patient) : [string, any] | undefined {
		if(isEmpty(patient.firstName)) return ['firstName', patient.firstName]
		if(isEmpty(patient.lastName)) return ['lastName', patient.lastName]
		if(isEmpty(patient.dni || '')) return ['dni', patient.dni]
		if(isEmpty(patient.phoneNumber || '')) return ['phoneNumber', patient.phoneNumber]
		if(isEmpty(patient.genre || '')) return ['genre', patient.genre]
		if(isEmpty(patient.birthDate || '')) return ['birthDate', patient.birthDate]
		if(isEmpty(patient.emergencyContact)) return ['emergencyContact', patient.emergencyContact]
		if(isEmpty(patient.address || '')) return ['address', patient.address]
		if(patient.educationLevel === undefined) return ['educationLevel', patient.educationLevel]
		if(isEmpty(patient.ocupation || '')) return ['ocupation', patient.ocupation]
		if(patient.workScheme === undefined) return ['workScheme', patient.workScheme]

		if(!Patient.isValidHealthBackground(patient)) return ['healthBackground', patient.healthBackground]

		return undefined
	}


	// *[Symbol.iterator]() {
    //     yield "Foo";
    //     yield "Bar";
    // }
}
